<template>
  <div class="style">
    <div class="onehome">
      <van-dropdown-menu active-color="#bc24d6">
        <van-dropdown-item v-model="value1" :options="option1" @change="getSelected" />
      </van-dropdown-menu>
      <van-search shape="round" placeholder="搜索活动/商品/服务" v-model="value" />
      <div class="imgbox">
        <van-icon name="chat-o" size='.6rem' @click='toModule("/personal/News")' />
        <van-icon name="scan" style="margin-left:6px" size='.6rem' @click='toScan' />
      </div>
    </div>
    <van-swipe id="vanSwipe" style="height: 140px;" :autoplay="5000" v-show="swipeList.length">
      <van-swipe-item v-for="(item, index) in swipeList" :key="index">
        <a :href="item.linkUrl == '' ? '/' : item.linkUrl.indexOf('home.tianan')==-1?'http://wechat.tianan.net/zpop?url='+item.linkUrl:item.linkUrl.split('http://home.tianan.net/navigator/')[1].split('/')[0] == 'activityDetails'?'http://wechat.tianan.net/ActivitiesDetalis/'+item.linkUrl.split('http://home.tianan.net/navigator/')[1].split('/')[1]:item.linkUrl.split('http://home.tianan.net/navigator/')[1].split('/')[0] == 'exclusiveActivitiesdetails'?'http://wechat.tianan.net/ExclusiveDetalis/'+item.linkUrl.split('http://home.tianan.net/navigator/')[1].split('/')[1]:'http://wechat.tianan.net/business/equipmentInfo/'+item.linkUrl.split('http://home.tianan.net/navigator/')[1].split('/')[2].split('?serviceId=')[1]+'/'+item.linkUrl.split('http://home.tianan.net/navigator/')[1].split('/')[2].split('?serviceId=')[0]" v-if="item.type === 2">
          <img :src="item.picUrl" :title="item.title" >
        </a>
        <img :src="item.picUrl" alt="" v-if="item.type === 1" class="videos" @click="videoClick(item.videoUrl)">
        <span class="playVideo" v-if="item.type === 1" @click="videoClick(item.videoUrl)">
          <van-icon name="play" />
        </span>
        <!-- <video :src="item.videoUrl" loop :muted="false" onpageshow v-if="item.type === 1" controls preload="meta"></video> -->
      </van-swipe-item>
    </van-swipe>
    <div class="newcar">
      <nav>
        <a v-if="this.currentParkId != 1003" class="entry" href="http://tawy.yun.bsgoal.net.cn/q/ParkRenewals_Index_moduleId=3">
          <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon04.png" alt="">
          </div>
          <h3>车卡续费</h3>
        </a>
        <router-link :to="`/propertyDetiles/${commonService.newCarCard}`" class="entry">
          <div class="icon" style="color: #4A90E2">
            <img height="50px" src="@/static/image/index/icon09.png" alt="">
          </div>
          <h3>车卡新办</h3>
        </router-link>
        <a class="entry" href="http://tawy.yun.bsgoal.net.cn/AppRedir/ParkPayment_Index_moduleId=2">
          <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon03.png" alt="">
          </div>
          <h3>临停缴费</h3>
        </a>
        <a v-if="this.currentParkId == 1000 || this.currentParkId == 1004" class="entry" href="http://szwgzf.unionpay.com/access/wx/main?bankType=7000000000000047">
          <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon07.png" alt="">
          </div>
          <h3>无感支付</h3>
        </a>
        <div v-else class="entry" @click='noToast'>
            <div class="icon" style="color: #4A90E2">
              <img height="50px" src="@/static/image/index/icon07.png" alt="">
            </div>
            <h3>无感支付</h3>
        </div>
        <a class="entry" href="http://tawy.yun.bsgoal.net.cn/q/qi_ix">
          <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon06.png" alt="">
          </div>
          <h3>电子发票</h3>
        </a>
      </nav>
    </div>
    <div class="notice" v-if="noticeList.length">
      <div class="content boxShadow">
        <router-link to="/noticelist" class="left" tag="div">
            <i style="color: #4A90E2" class="iconfont icon-tongzhi"></i>
            <span class="more">公告</span>
        </router-link>
        <div class="right">
          <van-swipe style="height: 26px;" vertical :autoplay="5000" :show-indicators=false>
            <van-swipe-item v-for="item in noticeList" :key="item.noticeId" >
              <router-link :to= "{ path: `/notice/${item.noticeId}` }" class="clearfix">
                <h3 class="textOver">{{ item.noticeTitle }}</h3>
                <!-- <span class="time">{{ item.createTime | DateFilter('MM-dd') }}</span> -->
              </router-link>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
    <nav>
      <router-link v-if="this.currentParkId == 1000" :to="`/propertyDetiles/1408`" class="entry">
        <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon15.png" alt="">
        </div>
         <h3>随手拍</h3>
      </router-link>
      <router-link v-else-if="this.currentParkId == 1004" :to="`/propertyDetiles/1409`" class="entry">
        <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon15.png" alt="">
        </div>
         <h3>随手拍</h3>
      </router-link>
      <router-link v-else :to="`/propertyDetiles/${commonService.bMove}`" class="entry">
        <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon06.png" alt="">
        </div>
         <h3>搬迁放行</h3>
      </router-link>
      <div class="entry" @click='toModule("/personal/Pay")'>
        <div class="icon" style="color: #4A90E2">
         <img height="50px" src="@/static/image/index/icon01.png" alt="">
        </div>
         <h3>物业查询</h3>
      </div>
      <router-link :to="`/propertyDetiles/${commonService.maintain}`" class="entry">
        <div class="icon" style="color: #F5A623">
          <img height="50px" src="@/static/image/index/icon02.png" alt="">
        </div>
         <h3>报修申请</h3>
      </router-link>
      <router-link v-if="this.currentParkId == 1000" :to="`/business/businessList/equipment/${commonService.houseProperty}`" class="entry">
        <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon03.png" alt="">
        </div>
         <h3>房产租售</h3>
      </router-link>
      <router-link v-else :to="`/propertyDetiles/${commonService.houseTere}`" class="entry">
        <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon10.png" alt="">
        </div>
         <h3>租户入伙</h3>
      </router-link>
      <div v-if="this.currentParkId == 1000" class="entry" @click='toModule("/qrcode/1000/3632")'>
        <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon05.png" alt="">
        </div>
         <h3>快递服务</h3>
      </div>
      <router-link v-else :to="`/business/businessList/equipment/${commonService.housecd}`" class="entry">
        <div class="icon" style="color: #4A90E2">
         <img height="50px" src="@/static/image/index/icon07.png" alt="">
        </div>
         <h3>场地申请</h3>
      </router-link>
      <router-link v-if="this.currentParkId == 1000" :to="`/propertyDetiles/${commonService.bMove}`" class="entry">
        <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon06.png" alt="">
        </div>
         <h3>搬迁放行</h3>
      </router-link>
      <router-link v-else :to="`/propertyDetiles/${commonService.guser}`" class="entry">
          <div class="icon" style="color: #4A90E2">
         <img height="50px" src="@/static/image/index/icon12.png" alt="">
        </div>
         <h3>管理员申请</h3>
      </router-link>
      <router-link v-if="this.currentParkId == 1000" :to="`/business/businessList/equipment/${commonService.housecd}`" class="entry">
        <div class="icon" style="color: #4A90E2">
         <img height="50px" src="@/static/image/index/icon07.png" alt="">
        </div>
         <h3>场地申请</h3>
      </router-link>
      <router-link v-else :to="`/business/businessList/equipment/${commonService.advertisingPosition}`" class="entry">
        <div class="icon" style="color: #4A90E2">
         <img height="50px" src="@/static/image/index/icon13.png" alt="">
        </div>
         <h3>广告投放</h3>
      </router-link>
      <div class="entry" @click='toModule("/property")'>
        <div class="icon" style="color: #4A90E2">
          <img height="50px" src="@/static/image/index/icon08.png" alt="">
        </div>
         <h3>更多</h3>
      </div>
    </nav>
    <div class="fangy">
        <div class="titlef">
          <h3>商务服务</h3>
          <p @click='toModule("/business/businessList/equipment/1062")'>更多<van-icon name="arrow" size='12px' /></p>
        </div>
        <div class="fcont" v-if="categoryList.length">
          <div class="fbox" v-for="(item2, index) in categoryList" :key="index" @click="jumpDetails(item2.serviceId,item2.facilitiesId)">
            <img width="100%" :src="item2.banner" alt="">
            <p class="textOver">{{ item2.title }}</p>
            <div class="textbootom">
              <span class="textOver"><van-icon name="underway-o" />{{ item2.createTime | DateFilter('yyyy-MM-dd')}}<span><van-icon name="cash-back-record" />{{ item2.price*0.01 }}</span></span>
            </div>
          </div>
        </div>
    </div>
    <div class="guangg">
      <van-swipe :autoplay="5000" indicator-color="white">
        <van-swipe-item><img src="@/static/image/index/pic1.jpg" alt="" @click='toModule("/qrcode/1000/3632")'></van-swipe-item>
        <van-swipe-item><img src="@/static/image/index/pic2.jpg" alt="" @click='toModule("/ExclusiveDetalis/1013")'></van-swipe-item>
        <van-swipe-item><img src="@/static/image/index/pic3.jpg" alt="" @click='toModule("/business/equipmentInfo/1149/1093")'></van-swipe-item>
        <van-swipe-item><img src="@/static/image/index/pic4.jpg" alt="" @click='toModule("/business/equipmentInfo/1150/1094")'></van-swipe-item>
      </van-swipe>
    </div>
    <div class="yuanq">
        <div class="titlef">
          <h3>园区活动</h3>
          <p @click='toModule("/parkCompleteSet/campusActivities")'>更多<van-icon name="arrow" size='12px' /></p>
        </div>
        <div class="huod" @click="detalis(activityList.activityId)">
          <img :src="activityList.banner" alt="">
          <h3>{{activityList.title}}</h3>
          <p>
            <span><van-icon name="clock-o" /> {{activityList.beginTime | DateFilter('yyyy-MM-dd hh:mm')}}</span>
          </p>
          <p class="huop">
            <span><van-icon name="location-o" /> {{activityList.provinceName}}{{activityList.cityName}}{{activityList.countyName}}{{activityList.address}}</span>
          </p>
        </div>
    </div>
    <!-- <div class="service">
      <h3>常用服务</h3>
      <div class="shortcut-list">
        <router-link tag="div" class="shortcut" :to="`/propertyDetiles/${commonService.maintain}`">
          <div class="icon">
            <img src="@/static/image/index/icon_baoxiu.png" alt="物业报修">
          </div>
          <div class="title">报修申请</div>
        </router-link>
        <router-link tag="div" class="shortcut" :to="`/propertyDetiles/${commonService.newCarCard}`">
          <div class="icon">
            <img src="@/static/image/index/icon_tingche.png" alt="车卡新办">
          </div>
          <div class="title">车卡办理</div>
        </router-link>
        <router-link tag="div" class="shortcut" :to="`/business/businessList/meetingRoom/${commonService.meetingRoom}`">
          <div class="icon">
            <img src="@/static/image/index/icon_hys.png" alt="会议室出租">
          </div>
          <div class="title">会议室出租</div>
        </router-link>
        <router-link tag="div" class="shortcut" :to="`/business/businessList/equipment/${commonService.advertisingPosition}`">
          <div class="icon">
            <img src="@/static/image/index/icon_guanggaowei.png" alt="园区广告位">
          </div>
          <div class="title">园区广告位</div>
        </router-link>
      </div>
      <div class="content">
        <template v-for="item in serviceList">
          <router-link tag="div" class="item"
                       v-if="serviceAttr[item.serviceFlag].path"
                       :key="item.serviceId"
                       :to="serviceAttr[item.serviceFlag].path"
                       :style="{'background-color': serviceAttr[item.serviceFlag].backgroundColor}"
          >
            <div class="title">{{item.serviceName}}</div>
            <div class="desc">{{item.content}}</div>
            <img :src="item.picUrl" class="icon">
          </router-link>
          <div class="item" v-else @click="commingSoon"
               :key="item.serviceId"
               :style="{'background-color': serviceAttr[item.serviceFlag].backgroundColor}"
          >
            <div class="title">{{item.serviceName}}</div>
            <div class="desc">{{item.content}}</div>
            <img :src="item.picUrl" class="icon">
          </div>
        </template>

      </div>
    </div> -->

    <!-- 遮罩层播放视频 -->
    <div class="mask" v-show="maskFlag">
      <div class="content">
        <p @click="closeMask">X</p>
        <video :src="videoUrl" controls :autoplay="maskFlag">您的浏览器暂不支持播放该视频，请升级至最新版浏览器。</video>
      </div>
    </div>
    <div>
    <van-tabbar v-model="active">
      <van-tabbar-item :to="`/index?parkId=${this.currentParkId}`"><div class="divicon"><van-icon size='22px' name="wap-home" />首页</div></van-tabbar-item>
      <van-tabbar-item to="/propertys"><div class="divicon"><van-icon size='22px' name="like-o" />服务</div></van-tabbar-item>
      <van-tabbar-item :to="`${this.currentParkId == 1003||this.currentParkId == 1000||this.currentParkId == 1006?'/parkCompleteSet/foodCourt':'/humanResource/jobList'}`"><div class="divicon"><van-icon size='22px' name="location-o" />附近</div></van-tabbar-item>
      <van-tabbar-item to="/parkCompleteSet/ExclusiveActivities"><div class="divicon"><van-icon size='22px' name="point-gift-o" />活动</div></van-tabbar-item>
      <van-tabbar-item to="/personal"><div class="divicon mydian"><van-icon size='22px' name="contact" />我的<span v-show="qirow>0" class="redd"></span></div></van-tabbar-item>
    </van-tabbar>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { Toast, DropdownMenu, DropdownItem, Search,Tabbar, TabbarItem } from 'vant';
import commonService from '@/static/commonService';
import axios from 'axios';
import $ from 'jquery';


export default {
  data() {
    return {
      active: 0,
      value1:'',
      value:'',
      qirow:0,
      option1: [
        { text: '福田天安', value: 1000 },
        { text: '重庆天安', value: 1001 },
        { text: '佛山天安', value: 1002 },
        { text: '龙岗天安', value: 1003 },
        { text: '东莞天安', value: 1004 },
        { text: '广州番禺天安', value: 1005 },
        { text: '深业U中心', value: 1006 },
        { text: '俊安苑', value: 1007 },
        { text: '常州天安', value: 1008 },
        { text: '天津天安', value: 1010 },
        { text: '江阴天安', value: 1011 },
        { text: '青岛天安', value: 1012 },
        { text: '高尔夫花园', value: 1015 },
        { text: '武汉天安', value: 1016 },
        { text: '中山天安', value: 1017 },
        { text: '西安天安', value: 1018 },
        { text: '上海天安', value: 1019 },
        { text: '广东南海', value: 1020 },
        { text: '西理工校企联盟', value: 0 },
      ],
      categoryList: [],
      activityList:[],
      welfareList:[],
      CooperationList:[],
      swipeList: [],
      noticeList: [],
      serviceList: [],
      serviceAttr: { // 首页8大服务的一些样式属性
        '1': {
          titleColor: '#A2770B',
          backgroundColor: '#F5DEA5',
          path: '/property',
        },
        '2': {
          titleColor: '#13476D',
          backgroundColor: '#D2E7F6',
          path: '/business',
        },
        '3': {
          titleColor: '#9A3535',
          backgroundColor: '#EBCBCB',
          path: '/governmentAffairs',
        },
        '4': {
          titleColor: '#865B1A',
          backgroundColor: '#DEC9A9',
          path: '/finance',
        },
        '5': {
          titleColor: '#C06134',
          backgroundColor: '#F0D2BE',
          path: '/humanResource',
        },
        '6': {
          titleColor: '#187439',
          backgroundColor: '#BFE5CC',
          path: '/parkCompleteSet',
        },
        '7': {
          titleColor: '#C5810C',
          backgroundColor: '#F3E4C2',
          path: '/production',
        },
        '8': {
          titleColor: '#C06134',
          backgroundColor: '#F1DFD4',
          path: '/bbs',
        },
      },
      maskFlag: false,
      videoUrl: null,
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
      commonService: {},
    }
  },
  methods: {
    ...mapMutations(['change_parkServiceList', 'change_currentParkId']),
    onChange(index) {
      // const videos = this.$el.querySelectorAll('#vanSwipe video');
      // videos.forEach((val) => {
      //   val.pause();
      // });
    },
    videoClick(src) {
      // 弹框播放视频
      this.maskFlag = true;
      this.videoUrl = src;
      document.body.style.overflow = 'hidden';
      // this.$el.querySelector(`#video${src}`).play();  // 点击播放视频
    },
    getSelected(value1){
      if(value1!=0){
        this.$router.push({ path: `/index?parkId=${value1}`});
        this.chereParkId();
        window.location.reload();
      }else{
        window.location.href ='http://home.tianan.net/alliance/';
      }
    },
    noToast(){
      Toast.fail('本园区暂未开通无感支付');
    },
    getValue: function(value){
        console.log('您选择了', value)
    },
    closeMask() {
      this.maskFlag = false;
      document.body.style.overflow = 'auto';
      this.$el.querySelector('.mask video').pause();
    },
    chereParkId() {  // 修改用户所属园区
      const $parkId = parseInt(location.href.split('parkId=')[1]?location.href.split('parkId=')[1]:this.currentParkId);
      this.$http.post(`${this.URL_PREFIX}/app/modify/user/info`, {
        parkId: $parkId,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          console.log(res);
        }
      });
    },
    getBanner() {  // 获取首页轮播和通知
      this.$http.post(`${this.URL_PREFIX}/app/get/park/banner/index`, {
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.swipeList = res.resData.bannerList;
          for(var i=0;i<this.swipeList.length;i++){
            if(window.btoa(this.swipeList[i].linkUrl).indexOf('=') == -1){
              this.swipeList[i].linkUrl = window.btoa(this.swipeList[i].linkUrl)
            }else{
              this.swipeList[i].linkUrl = window.btoa(this.swipeList[i].linkUrl+'/')
            }

          }
          this.noticeList = res.resData.noticeList;
        }
      });
    },
    getarrears() {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/arrears`, {
        parkId: this.currentParkId,
      },{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          this.qirow = parseInt(res.resData.total);
        }
      });
    },
    gettianq(serAreaId) {
      var serArea = serAreaId;
      var cityname;
      if (serArea == 1000) {
            cityname = "福田";
        } else if (serArea == 1001) {
            cityname = "重庆";
        }else if(serArea == 1002){
            cityname = "佛山";
        }else if(serArea == 1003){
            cityname = "龙岗";
        }else if(serArea == 1004){
            cityname = "东莞";
        }else{
            cityname = "福田";
        }
      $.ajax({
            type: "get",
            // contentType: 'application/json; charset=UTF-8',
            url: 'http://v.juhe.cn/weather/index?dtype=&format=2&key=54908120d2498240f15de8ed87698886&cityname='+cityname,
            dataType: 'jsonp',
            // jsonp: "jsonpcallback",
            async: false,
            success: function (data) {
               console.log(data)
            }
        });
    },
    getList() {  // 获取列表
      this.$http.post(`${this.URL_PREFIX}/app/get/facilities/rent/list`, {
        parkId: this.currentParkId,
        serviceId: this.commonService.houseProperty,
        currPage: 1,
        pageRows: 4,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.categoryList = res.resData.pageList.length > 4 ? res.resData.pageList.slice(0,4) : res.resData.pageList;
        }else{
          this.$toast(res.resDesc);
        }
      });
    },
    getIndexMsg() {  // 获取首页活动
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/index`, {
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.activityList = res.resData.activityList?res.resData.activityList[0]:[];
          this.welfareList = res.resData.welfareList;
          this.CooperationList = res.resData.askList;
        }
      });
    },
    jumpDetails(serviceId,index) {
      this.$router.push({ path: `/business/equipmentInfo/${serviceId}/${index}`})
    },
    getService() {  // 获取八大服务
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`, {
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.serviceList = res.resData.pageList;
          let arr = [];
          this.serviceList.forEach((val) => {
            arr.push({
              serviceFlag: val.serviceFlag,
              serviceName: val.serviceName,
              serviceId: val.serviceId,
              children: val.childrenList
            })
          });
          this.change_parkServiceList(arr);
        }
      });
    },
    toModule(path) {
      this.$router.push({ path: path });
    },
    detalis(activityId) {
      this.$router.push({ path: `/ActivitiesDetalis/${activityId}`, query:this.$route.query });
    },
    toScan() {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else {

        this.getJsSdkConfigParams();
      }
    },
    // 获取微信扫码配置
    getJsSdkConfigParams() {
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
        url: location.href.split('#')[0]
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.scanConfig.appId = res.resData.appId;
          this.scanConfig.timestamp = res.resData.timestamp;
          this.scanConfig.nonceStr = res.resData.nonceStr;
          this.scanConfig.signature = res.resData.signature;
          this.config();
        } else {
          Toast.fail({ duration: 1500, message: res.resDesc });
        }
      });
    },
    // 扫码
    config() {
      wx.config({
        debug: false,
        appId: this.scanConfig.appId,
        timestamp: this.scanConfig.timestamp,
        nonceStr: this.scanConfig.nonceStr,
        signature: this.scanConfig.signature,
        jsApiList: ['checkJsApi', 'scanQRCode']
      });


      // 配置出错
      wx.error((res) => {
        Toast.fail({ duration: 1500, message: `${res.errMsg}` });
      });

      // 配置成功之后的回调
      wx.ready(() => {
        wx.checkJsApi({
          jsApiList : ['scanQRCode'],
          success : (res) => {
          }
        });
        wx.scanQRCode({
          /**
           * 此处为0才能使用PC官网的扫一扫登陆功能
           * 因为微信的登陆二维码做了特殊处理，必须直接由微信扫码跳转过去才行
           * 例如把微信登陆二维码识别为文本url后再点击也是不行的，必须由微信直接扫码跳转（微信会识别来源方式）
           * 所以如果要兼容官网微信登陆功能，这里就无法由我们自行处理二维码内容
           */
          needResult : 0,
          scanType : ["qrCode"],
        });
      });
    },

    commingSoon(){
      Toast('内容丰富中，敬请期待');
    },
  },
  created() {
    this.value1 = this.currentParkId;
    if(this.$route.query.parkId){
      this.change_currentParkId(Number(this.$route.query.parkId));
    }
    this.commonService = commonService[process.env.commonServiceConfKey][this.currentParkId];
    this.value1 = parseInt(location.href.split('parkId=')[1]?location.href.split('parkId=')[1]:1000);
    console.log(this.currentParkId);
    // if(this.currentParkId==1000){
    //   window.location.href ='http://www.tianans.com/mobile/?parkId=1000';
    // }
    // if(this.currentParkId==1001){
    //   window.location.href ='http://www.tianans.com/mobile/?parkId=1001';
    // }
    // if(this.currentParkId==1002){
    //   window.location.href ='http://www.tianans.com/mobile/?parkId=1002';
    // }
    // if(this.currentParkId==1003){
    //   window.location.href ='http://www.tianans.com/mobile/?parkId=1003';
    // }
    // if(this.currentParkId==1004){
    //   window.location.href ='http://www.tianans.com/mobile/?parkId=1004';
    // }
    // if(this.currentParkId==1005){
    //   window.location.href ='http://www.tianans.com/mobile/?parkId=1005';
    // }
    // if(this.currentParkId==1006){
    //   window.location.href ='http://www.tianans.com/mobile/?parkId=1006';
    // }
    // if(this.currentParkId==1008){
    //   window.location.href ='http://www.tianans.com/mobile/?parkId=1008';
    // }
    // if(this.currentParkId==1011){
    //   window.location.href ='http://www.tianans.com/mobile/?parkId=1011';
    // }
    // if(this.currentParkId==1012){
    //   window.location.href ='http://www.tianans.com/mobile/?parkId=1012';
    // }
  },
  mounted() {
    this.value1 = this.currentParkId;
    // console.log(this.currentParkId);
    this.getBanner();
    // this.chereParkId();
    // this.gettianq(this.currentParkId);
    this.getService();
    this.getList();
    this.getIndexMsg();
    // if (this.token) {
    //   this.getarrears();
    // }else{
    //   console.log(6666);
    // }
  },
  computed: {
    ...mapGetters(['currentParkId', 'token']),
  },
  watch: {
    $route() {
      this.getList();
      this.getIndexMsg();
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.style {
  background-color: #fff;
}

.divicon{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  i{
    padding-bottom: .1rem;
  }
}
.mydian{
  position: relative;
  .redd{
    width:7px;
    height: 7px;
    border-radius: 50%;
    position: absolute;
    top: 0px;
    right: 0px;
    background: #eb3047;
  }
}

.onehome{
  background: #EFEFF4;
  width: 100%;
  height: 1.2rem;
  display: flex;
  justify-content:space-around;
  align-items: center;
  .van-dropdown-menu{
    background: #EFEFF4;
    height: 46px;
    line-height: 16px;
    color: #bc24d6;
  }
  .van-search{
    background: #EFEFF4 !important;
    width: 5.6rem;
    .van-search__content--round{
      height: .68rem;
      display: flex;
      align-items: center;
    }
  }
  .imgbox{
    height: 100%;
    display: flex;
    align-items: center;
  }
}
.van-swipe .van-swipe-item{
  background: #fff !important;
}
.huod{
  background: #fff;
  width: 100%;
  height: 5.38rem;
  display: flex;
  justify-content: center;
  flex-direction:column ;
  // padding: .4rem 0 .8rem 0;
  margin-bottom: px2rem(60);
  img{
    // width: 94%;
    // height: 100%;
    height: 3.2rem;
    object-fit: cover;
    border-radius: 6px;
    margin: 0 auto;
  }
  h3{
    margin: .2rem 0;
    padding-left: 0.24rem;
    font-size: .4rem;
  }
  p{
    padding-left: 0.24rem;
    font-size: px2rem(26);
    color: #949fa6;
  }
  .huop{
    padding-bottom: .32rem;
  }
}

.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0,0,0,.8);
  .content {
    position: absolute;
    border-radius: 4px;
    top: 4rem;
    left: 0;
    right: 0;
    bottom: 4rem;
    // margin: 20px;
    background-color: #fff;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    p {
      height: 1rem;
      line-height: 1rem;
      text-align: right;
      padding-right: 20px;
      font-size: .5rem;
    }
    video {
      flex: 1;
      width: 100%;
      cursor: pointer;
    }
  }
}
.guangg{
  height: px2rem(260);
  padding: .1rem .4rem;
  img{
  border-radius: .18rem;
  }

  .van-swipe{
  padding-top: px2rem(15);
  }

}
.van-swipe {
  height: px2rem(230);
  position: relative;
  .van-swipe-item {
    background-color: #000;
    display: flex;
    align-items: center;
    img{
      object-fit: cover;
    }
    .playVideo {
      position: absolute;
      width: 1.066667rem;
      height: 1.066667rem;
      // background-color: rgba(0,0,0,.8);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        color: #fff;
        font-size: 1.066667rem;
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
  video {
    width: 100%;
    height: 100%;
    background-color: #000;
  }
}
nav {
  display: flex;
  // height: 5.606667rem;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: .32rem 0;
  .entry {
    // flex: 1;
    width: 2.16rem;
    padding-top: .386667rem;
    .icon {
      // width: 1.38rem;
      // height: 1.38rem;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      img{
        border-radius: 50%;
      }
      .iconfont {
        font-size: .72rem;
      }
    }
    h3 {
      font-size: .363333rem;
      line-height: 1rem;
      text-align: center;
    }
  }
}
.newcar{
  // padding-top: px2rem(24);
  // padding-bottom: px2rem(24);
  // background-color: rgb(245, 245, 245);
  nav{
    padding: .2rem 0;
    .entry{
      width: 1.86rem;
    }
  }
}
.notice {
  padding-top: px2rem(24);
  padding-bottom: px2rem(24);
  background-color: rgb(245, 245, 245);
  height: 1.08rem;
  .content {
    height: 100%;
    // margin: 0 .266667rem;
    background-color: #fff;
    display: flex;
    align-items: center;
    .left {
      font-size: 16px;
      text-align: center;
      margin-left: 10px;
      .icon-tongzhi {
        color: #E66266;
        font-size: .30rem !important;
      }
      .more {
        // font-size: px2rem(36);
        color: #288ff8;
        margin-top: px2rem(9);
        // padding-left: px2rem(10);
        font-weight: 700;
        padding-right: px2rem(40);
        background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(rgb(44, 174, 214)), to(rgb(41, 15, 136)));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .right {
      flex: 1;
      padding: px2rem(10) 0;
      a {
        padding: px2rem(10) .32rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3 {
          width: 5.6rem;
          // line-height: 1;
          float: left;
          font-size: px2rem(28);
        }
        .time {
          float: right;
          line-height: 1;
          width: 1rem;
          font-size: px2rem(24);
          color: rgb(102, 102, 102);
          text-align: right;
        }
      }
    }
  }
}
.fangy {
  padding-bottom: px2rem(24);
  padding-top: px2rem(24);
  background-color: rgb(245, 245, 245);
  .titlef{
    background: #fff;
    display: flex;
    justify-content:space-between;
    padding: px2rem(24) px2rem(36);
    h3{
      border-left:4px solid #288ff8;
      padding-left: px2rem(18);
      font-weight: 600;
      height: 0.49rem;
      line-height: .49rem;
    }
    p{
      font-size: px2rem(26);
      color: #949fa6;
      display: flex;
      align-items: center;
    }
  }
  .fcont{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    background: #fff;
    padding: px2rem(16);
    .fbox{
      height: 3.65333rem;
      line-height: 1;
      width: 4.25333rem;
      margin: 0.12rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      position: relative;
      box-shadow: 2px 2px 6px #bcbcb2;
      border-radius: 0.2rem;
      img{
        border-radius: 0.2rem 0.2rem 0 0;
      }
      .textOver{
        height: .56rem;
        line-height: .56rem;
        // text-align: center;
        margin-left: .3rem;
        font-size: .386rem;
      }
      .textbootom{
        height: .6rem;
        display: flex;
        align-items: center;
        // justify-content: center;
        span{
          display: flex;
          align-items: center;
          color: #6e7579;
          margin-left: .3rem;
          font-size: px2rem(23);
        }
      }
    }
  }
}
.yuanq{
  height: 7.8889rem;
  // padding-top: px2rem(24);
  padding-bottom: .4rem;
  background-color: rgb(245, 245, 245);
  display: flex;
  justify-content: center;
  flex-direction:column ;
  .titlef{
  background: #fff;
  display: flex;
  justify-content:space-between;
  padding: px2rem(24);
    h3{
      border-left:4px solid #288ff8;
      padding-left: px2rem(18);
      font-weight: 600;
      height: 0.49rem;
      line-height: .49rem;
    }
    p{
      font-size: px2rem(26);
      color: #949fa6;
    }
  }
  
}
.service {
  padding: px2rem(40) px2rem(24) px2rem(24);
  h3 {
    font-size: px2rem(32);
    font-weight: bold;
    line-height: 1;
  }
  .shortcut-list{
    display: flex;
    justify-content: space-around;
    margin-top: px2rem(30);
    margin-bottom: px2rem(80);
    .shortcut{
      display: flex;
      align-items: center;
      flex-flow: column;
      .icon{
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #EBEBEB;
        border-radius: 50%;
        width: px2rem(100);
        height: px2rem(100);
        img{
          width: px2rem(80);
          height: px2rem(80);
        }
      }
      .title{
        margin-top: px2rem(20);
        font-size: px2rem(24);
        line-height: 1;
        color: #333;
      }
    }
  }
  .content{
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .item{
      height: px2rem(214);
      padding: px2rem(28) px2rem(30);
      line-height: 1;
      width: 49%;
      margin-bottom: px2rem(6);
      box-sizing: border-box;
      position: relative;
      .title{
        font-size: px2rem(30);
      }
      .desc{
        margin-top: px2rem(20);
        font-size: px2rem(22);
        color: #666;
      }
      .icon{
        position: absolute;
        right: px2rem(40);
        bottom: px2rem(12);
        max-height: px2rem(80);
      }
    }
  }
  .test{
    width: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/Index.vue